import { Address } from "@/Common/Api/Contacts/Dto/Address";

interface IAddressSectionProps {
    addresses: Address[];
}

function AddressSection(props: IAddressSectionProps): JSX.Element {
    const addresses = props.addresses;

    return (
        <div>
            <div className="view-section-header">
                <h3 className="view-section-title">{cacheStore.GetString("AddressLabel")}</h3>
            </div>
            <div className="view-section-body">
                {addresses.sortByPropertyDesc(c => c.IsPreferred).map((address: Address, idx: number) => (
                    <div id={"__i" + idx} key={"__k" + idx} style={{ "marginBottom": "10px" }}>
                        <div className="row">
                            <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                                <label className="form-label">{cacheStore.GetString("TypeLabel")}</label>
                            </div>
                            <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                                <strong>{cacheStore.GetLocalizedValueByLookupId(address.ContactPointTypeLookupId)}</strong>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                                <label className="form-label">{cacheStore.GetString("StreetAddressLabel")}</label>
                            </div>
                            <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                                <strong>{address.StreetAddress}</strong>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                                <label className="form-label">{cacheStore.GetString("CityLabel")}</label>
                            </div>
                            <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                                <strong>{address.City}</strong>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                                <label className="form-label">{cacheStore.GetString("CountryLabel")}</label>
                            </div>
                            <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                                <strong>{cacheStore.GetLocalizedValueByLookupId(address.CountryLookupId)}</strong>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                                <label className="form-label">{cacheStore.GetString("StateProvinceLabel")}</label>
                            </div>
                            <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                                <strong>{cacheStore.GetLocalizedValueByLookupId(address.StateLookupId)}</strong>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                                <label className="form-label">{cacheStore.GetString("ZipPostalCodeLabel")}</label>
                            </div>
                            <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                                <strong>{address.ZipCode}</strong>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default AddressSection;
